module.exports = __webpack_public_path__ + "static/img/fredericton2.1593cf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/fredericton2.jpg
// module id = 88
// module chunks = 9